import { fontSize } from "constants/fontSize";
import { newColors } from "constants/newColors";
import styled, { css } from "styled-components";

export type ButtonProps = {
  className?: string;
  variant?: VariantTypes;
  size?: ButtonSizes;
};

// TODO:今後グローバル変数に変更する予定
enum buttonColor {
  priamry = "#e47e1e",
  white = "#fcfcfb",
  secondary = "#f8f7f5",
  gray = "#6c6c6c",
}

export type VariantTypes =
  | "primary"
  | "primary-reverse"
  | "secondary"
  | "white";

export type ButtonSizes = "small" | "medium" | "large" | "xlarge";
export const createButtonStyleByVariantTypes = (variant?: VariantTypes) => {
  switch (variant) {
    case "primary":
      return css`
        background: ${buttonColor.priamry};
        color: ${buttonColor.white};
      `;
    case "primary-reverse":
      return css`
        background: ${buttonColor.white};
        color: ${buttonColor.priamry};
      `;
    case "secondary":
      return css`
        background: ${buttonColor.secondary};
        color: ${buttonColor.gray};
      `;
    case "white":
      return css`
        background: ${buttonColor.white};
        color: ${buttonColor.gray};
      `;
  }
};

export const createButtonStyleBySize = (size?: ButtonSizes) => {
  switch (size) {
    case "small":
      return css`
        font-size: ${fontSize.xxsmall};
      `;
    case "medium":
      return css`
        font-size: ${fontSize.xsmall};
      `;
    case "large":
      return css`
        font-size: ${fontSize.small};
      `;
    case "xlarge":
      return css`
        font-size: ${fontSize.xlarge};
      `;
  }
};

export const StyledButton = styled.button<ButtonProps>`
  border: 0px;
  padding: 0.4em 2.5em;
  border: solid 1px ${newColors.border};
  border-radius: 20px;
  font-weight: bold;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }
  :disabled {
    cursor: default;
    opacity: 0.3;
  }

  ${({ variant }) => {
    return createButtonStyleByVariantTypes(variant);
  }}
  ${({ size }) => {
    return createButtonStyleBySize(size);
  }}
`;
